type ShellWindow = {
  __TAURI_INTERNALS__?: unknown;
  __TAURI__?: unknown;
};

export function isDesktopShell(
  win: ShellWindow | undefined = typeof window === 'undefined' ? undefined : window,
): boolean {
  return !!win && ('__TAURI_INTERNALS__' in win || '__TAURI__' in win);
}

export function isLocalHost(hostname?: string): boolean {
  const h = hostname ?? (typeof window === 'undefined' ? '' : window.location.hostname);
  return h === 'localhost' || h === '127.0.0.1' || h === '[::1]';
}

export function postLoginPath(
  win: ShellWindow | undefined = typeof window === 'undefined' ? undefined : window,
): string {
  return isDesktopShell(win) ? '/studio' : '/dashboard';
}

export function allowLocalModels(
  win: ShellWindow | undefined = typeof window === 'undefined' ? undefined : window,
  hostname?: string,
): boolean {
  return isDesktopShell(win) || isLocalHost(hostname);
}
